import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Typography from '@material-ui/core/Typography';

const UserInfo = ({ user, classes }) => (
    <div className={classes.wrapper}>
        <Typography noWrap className={classes.userName}>
            {user.firstName} {user.lastName}
        </Typography>
        <Typography variant="caption" noWrap>
            {user.email}
        </Typography>
    </div>
);

UserInfo.propTypes = {
    user: PropTypes.object.isRequired,
};

const style = ({ spacing, palette }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        paddingLeft: spacing.unit * 2,
    },
    userName: {
        color: palette.text.tertiary,
    },
});

export default injectSheet(style)(UserInfo);



// WEBPACK FOOTER //
// ./src/components/users/UserInfo.js